export default __webpack_public_path__ + "static/media/avatar_dog5.7d941cc2.mp3";